import { Box, Button, Divider, IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { MetricItem, MetricsRowBlock } from "../../../types/storyMap";
import MetricItemFields from "./MetricItemFields";
import type { ScopeLists } from "../useScopeLists";
import type { StoryScopeInfo } from "../useStoryScope";

interface MetricsRowBlockEditorProps {
  block: MetricsRowBlock;
  onChange: (patch: Partial<MetricsRowBlock>) => void;
  scope: StoryScopeInfo;
  lists: ScopeLists;
}

const emptyItem = (): MetricItem => ({
  label: "",
  value: "",
  units: "",
  source: { kind: "manual" },
});

export default function MetricsRowBlockEditor({
  block,
  onChange,
  scope,
  lists,
}: MetricsRowBlockEditorProps) {
  const setItem = (index: number, patch: Partial<MetricItem>) => {
    const items = block.items.map((item, i) =>
      i === index ? { ...item, ...patch } : item
    );
    onChange({ items });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      {block.items.map((item, index) => (
        <Box key={index}>
          {index > 0 && <Divider sx={{ mb: 1.5 }} />}
          <Box sx={{ display: "flex", gap: 0.5, alignItems: "flex-start" }}>
            <Box sx={{ flex: 1 }}>
              <MetricItemFields
                item={item}
                onChange={(patch) => setItem(index, patch)}
                scope={scope}
                lists={lists}
              />
            </Box>
            <Tooltip title="Remove metric" arrow>
              <IconButton
                size="small"
                onClick={() =>
                  onChange({ items: block.items.filter((_, i) => i !== index) })
                }
              >
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      ))}
      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={() => onChange({ items: [...block.items, emptyItem()] })}
        sx={{ alignSelf: "flex-start", textTransform: "none" }}
      >
        Add metric
      </Button>
    </Box>
  );
}
